import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {
    MonitoringTypeBadgeVariant,
    resolveMonitoringTypeBadge,
} from '../vehicle-monitoring/vehicle-monitoring.constants';

@Component({
    selector: 'app-monitoring-type-badge',
    standalone: true,
    imports: [CommonModule],
    template: `
        <span *ngIf="badge as resolved" class="monitoring-type-badge" [ngClass]="resolved.variant">
            {{ resolved.label }}
        </span>
    `,
    styles: [`
        .monitoring-type-badge {
            display: inline-flex;
            align-items: center;
            padding: 0.2rem 0.55rem;
            border-radius: 999px;
            font-size: 0.72rem;
            font-weight: 700;
            letter-spacing: 0.04em;
            text-transform: uppercase;
            line-height: 1.2;
            white-space: nowrap;
        }

        .monitoring-type-badge.gps-inactive {
            background: #DBEAFE;
            color: #2563EB;
        }

        .monitoring-type-badge.service-due {
            background: #FFEDD5;
            color: #EA580C;
        }

        .monitoring-type-badge.higher-dues {
            background: #FEE2E2;
            color: #DC2626;
        }

        .monitoring-type-badge.insurance-due {
            background: #EDE9FE;
            color: #7C3AED;
        }

        .monitoring-type-badge.rc-expiry {
            background: #FEF9C3;
            color: #CA8A04;
        }

        .monitoring-type-badge.permit-expiry {
            background: #DCFCE7;
            color: #16A34A;
        }

        .monitoring-type-badge.others {
            background: #E5E7EB;
            color: #374151;
        }
    `]
})
export class MonitoringTypeBadgeComponent {
    @Input() monitoringType: string | null | undefined = '';
    @Input() displayLabel: string | null | undefined = '';

    get badge(): {label: string; variant: MonitoringTypeBadgeVariant} | null {
        return resolveMonitoringTypeBadge(this.monitoringType, this.displayLabel);
    }
}
